const Gconf = {
  key:
    //'AIzaSyBilKfYMwh18I7TaLpH4UvclwJoJVFfwzg'
     'googlekey.udisemdengue'

};

export default Gconf;
